$(document).ready(function () {

    /* ADJUST SELECT ----------------------------- */

    function adjustWidth($select) {
        let $widthSpan = $select.siblings(".select-width");
        $widthSpan.text($select.find("option:selected").text());
        $select.width($widthSpan.outerWidth() + 20);
    }

    $('.new-footer select').each(function () {
        adjustWidth($(this)); // Initialize width
    });

    $('.new-footer select').on("change", function () {
        adjustWidth($(this));
    });

    if ($('.show-up').length) {
        $('.show-up').each(function () {
            let text = $(this).html();
            $(this).html(`<span>${text}</span>`);
        });
    }

    if ($('.decrypt').length) {
        $('.decrypt').each(function() {
            const chars = '!@#$%^&*()_+-=[]{}|;:",.<>?/\\~`';

            $(this).html($(this).text().trim().split('').map(c => {
                return `<span data-i="${c === ' ' ? '&nbsp;' : c}">${chars[Math.floor(Math.random() * chars.length)]}</span>`;
            }).join(''));
        });
    }

    if ($('.count-up').length) {
        $('.count-up').each(function() {
            let val = $(this).text().trim();

            $(this).attr('data-max', val).html('0');
        });
    }

    if ($('.moving-banner').length) {
        $('.moving-banner .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: true,
                smartSpeed: 800,
                margin: 0,
            });

            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.gtre').length) {
        $('.gtre .count-it').each(function () {
            let $this = $(this);

            let $countElement = $this;
            let originalText = $countElement.text().trim();

            function randomChar() {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=~`[]{}|;:,.?';
                return chars[Math.floor(Math.random() * chars.length)];
            }

            let length = originalText.length;

            let random1 = Array.from({
                length
            }, () => randomChar()).join('');
            let random2 = Array.from({
                length
            }, () => randomChar()).join('');
            let random3 = Array.from({
                length
            }, () => randomChar()).join('');
            let random4 = Array.from({
                length
            }, () => randomChar()).join('');

            // Replace HTML
            $countElement.html(`
                <span>${random1}</span>
                <span>${random2}</span>
                <span>${random3}</span>
                <span>${random4}</span>
                <span>${originalText}</span>
            `);
        });
    }

    if ($('.featured-products').length) {
        $('.featured-products').each(function() {
            let sync1 = $(this).find('.product-media .owl-carousel');
            let sync2 = $(this).find('.thumbnail .owl-carousel');

            let syncedSecondary = false;

            sync1.owlCarousel({
                items: 1,
                slideSpeed: 2000,
                nav: false,
                dots: false,
                loop: false,
                margin: 20,
                autoHeight: true
            }).on('changed.owl.carousel', syncPosition);


            sync2.on('initialized.owl.carousel', function () {
                sync2.find(".owl-item").eq(0).addClass("current");
            })
            .owlCarousel({
                items: 4,
                nav: false,
                dots: false,
                margin: 50,
                smartSpeed: 200,
                slideSpeed: 500,
                slideBy: 4,
                stagePadding: 20,
                responsive: {
                    0: {
                        margin: 30
                    },
                    1250: {
                        margin: 50
                    }
                }
            }).on('changed.owl.carousel', syncPosition2);

            function syncPosition(el) {
                //if you set loop to false, you have to restore this next line
                let current = el.item.index;
                
                //if you disable loop you have to comment this block
                /* let count = el.item.count-1;
                let current = Math.round(el.item.index - (el.item.count/2) - .5);
                
                if(current < 0) {
                    current = count;
                }
                if(current > count) {
                    current = 0;
                } */
                
                //end block

                sync2.find(".owl-item")
                    .removeClass("current")
                    .eq(current)
                    .addClass("current");
                let onscreen = sync2.find('.owl-item.active').length - 1;
                let start = sync2.find('.owl-item.active').first().index();
                let end = sync2.find('.owl-item.active').last().index();

                if (current > end) {
                    sync2.data('owl.carousel').to(current, 100, true);
                }
                if (current < start) {
                    sync2.data('owl.carousel').to(current - onscreen, 100, true);
                }
            }

            function syncPosition2(el) {
                if (syncedSecondary) {
                    let number = el.item.index;
                    sync1.data('owl.carousel').to(number, 100, true);
                }
            }

            sync2.on("click", ".owl-item", function (e) {
                e.preventDefault();
                let number = $(this).index();
                sync1.data('owl.carousel').to(number, 300, true);
            });
        });
    }

    if ($('.ratings-awards').length) {
        $('.ratings-awards .owl-carousel.ratings').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                rtl: true,
                items: 1,
                nav: false,
                dots: false,
                loop: true,
                autoWidth: true,
                center: true,
                smartSpeed: 6500,
                autoplay: true,
                autoplayTimeout: 6500,
                autoplaySpeed: 6500,
                margin: 50,
                mouseDrag: false,
                touchDrag: false,
                slideTransition: 'linear'
            });

            $(this).trigger('refresh.owl.carousel');
        });
        $('.ratings-awards .owl-carousel.awards').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: true,
                autoWidth: true,
                center: true,
                smartSpeed: 6500,
                autoplay: true,
                autoplayTimeout: 6500,
                autoplaySpeed: 6500,
                margin: 50,
                mouseDrag: false,
                touchDrag: false,
                slideTransition: 'linear'
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.specs-slider:not(.v2)').length) {
        $('.specs-slider:not(.v2)').each(function () {
            let el = $(this);
            let timeOut;

            const swiperT = new Swiper(el.find('.swiper-title')[0], {
                direction: 'vertical',
                effect: 'slide',
                slidesPerView: 1,
                loop: true,
                allowTouchMove: false
            });

            const swiperD = new Swiper(el.find('.swiper-desc')[0], {
                direction: 'vertical',
                effect: 'slide',
                slidesPerView: 1,
                loop: true,
                allowTouchMove: false
            });

            // Set max height for swiper-title and swiper-desc
            function setMaxHeight(selector) {
                let maxH = 0;
                el.find(selector + ' .swiper-slide').each(function () {
                    let h = $(this).outerHeight(true);
                    if (h > maxH) maxH = h;
                });
                el.find(selector).height(maxH + 'px');
                el.find(selector + ' .swiper-slide > *').height(maxH + 'px');
            }

            setMaxHeight('.swiper-title');
            setMaxHeight('.swiper-desc');

            // Initialize both carousels (desktop & mobile)
            el.find('.owl-carousel').each(function () {
                let $carousel = $(this);

                $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    loop: true,
                    smartSpeed: 800,
                    margin: 20,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    mouseDrag: false,
                    touchDrag: false,
                    onInitialized: function () {
                        if ($carousel.is(':visible')) handleSlideAdvance($carousel);
                    },
                    onTranslate: function () {
                        el.find('.slide-nav').css('pointer-events', 'none');
                    },
                    onTranslated: function () {
                        el.find('.slide-nav').css('pointer-events', 'unset');
                        if ($carousel.is(':visible')) handleSlideAdvance($carousel);
                    }
                });

                $carousel.trigger('refresh.owl.carousel');
            });

            // Slide navigation buttons
            el.find('.slide-nav button').on('click', function () {
                let $activeCarousel = el.find('.owl-carousel:visible');

                $activeCarousel.find('video').each(function () {
                    this.pause();
                });

                clearTimeout(timeOut);
                timeOut = setTimeout(function () {
                    el.find('.owl-item:not(.active) video').each(function () {
                        this.currentTime = 0;
                    });
                    el.find('.owl-item.active video').get(0)?.play();
                }, 800);

                if ($(this).hasClass('owl-next')) {
                    $activeCarousel.trigger('next.owl.carousel');
                    swiperT.slideNext();
                    swiperD.slideNext();
                } else {
                    $activeCarousel.trigger('prev.owl.carousel');
                    swiperT.slidePrev();
                    swiperD.slidePrev();
                }
            });

            // Auto advance after video ends (only for visible carousel)
            function handleSlideAdvance($carousel) {
                el.find('.owl-item:not(.active) video').each(function () {
                    this.pause();
                });

                let $activeItem = $carousel.find('.owl-item.active');
                let $video = $activeItem.find('video');

                // Remove any previous .autoadvance listeners to prevent duplicates
                el.find('video').off('.autoadvance');

                // Only bind if a video exists
                if ($video.length) {
                    $video.off('.autoadvance').on('ended.autoadvance', function () {
                        $carousel.trigger('next.owl.carousel');
                        swiperT.slideNext();
                        swiperD.slideNext();

                        clearTimeout(timeOut);
                        timeOut = setTimeout(function () {
                            el.find('.owl-item:not(.active) video').each(function () {
                                this.currentTime = 0;
                            });
                            el.find('.owl-item.active video').get(0)?.play();
                        }, 800);
                    });

                    // Play video
                    $video.get(0)?.play();
                }
            }

            // Pause on hover of text
            el.find('.swiper-desc .body-xl').on('mouseenter', function () {
                el.find('.owl-carousel:visible .owl-item.active video').get(0)?.pause();
            });

            el.find('.swiper-desc .body-xl').on('mouseleave', function () {
                el.find('.owl-carousel:visible .owl-item.active video').get(0)?.play();
            });
        });
    }

    if ($('.specs-slider.v2').length) {
        $('.specs-slider.v2').each(function () {
            let el = $(this);
            let timeOut;

            const swiperT = new Swiper(el.find('.swiper-title')[0], {
                direction: 'vertical',
                effect: 'slide',
                slidesPerView: 1,
                loop: true,
                allowTouchMove: false
            });

            // Match swiper-title height to tallest slide
            let maxTitleHeight = 0;
            el.find('.swiper-title .swiper-slide').each(function () {
                let h = $(this).outerHeight(true);
                if (h > maxTitleHeight) maxTitleHeight = h;
            });
            el.find('.swiper-title').height(maxTitleHeight + 'px');
            el.find('.swiper-title .swiper-slide > *').height(maxTitleHeight + 'px');

            // Initialize each carousel inside .specs-slider.v2
            el.find('.owl-carousel').each(function () {
                let $carousel = $(this);

                $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    loop: true,
                    smartSpeed: 100,
                    margin: 20,
                    mouseDrag: false,
                    touchDrag: false,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    onInitialized: function () {
                        if ($carousel.is(':visible')) handleSlideAdvance2($carousel);
                    },
                    onTranslate: function () {
                        el.find('.slide-nav').css('pointer-events', 'none');
                    },
                    onTranslated: function () {
                        el.find('.slide-nav').css('pointer-events', 'unset');
                        if ($carousel.is(':visible')) handleSlideAdvance2($carousel);
                    }
                });

                $carousel.trigger('refresh.owl.carousel');
            });

            // Slide navigation click
            el.find('.slide-nav button').on('click', function () {
                let $activeCarousel = el.find('.owl-carousel:visible');

                $activeCarousel.find('video').each(function () {
                    this.pause();
                });

                clearTimeout(timeOut);
                timeOut = setTimeout(function () {
                    el.find('.owl-item:not(.active) video').each(function () {
                        this.currentTime = 0;
                    });
                    el.find('.owl-item.active video').get(0)?.play();
                }, 800);

                if ($(this).hasClass('owl-next')) {
                    $activeCarousel.trigger('next.owl.carousel');
                    swiperT.slideNext();
                } else {
                    $activeCarousel.trigger('prev.owl.carousel');
                    swiperT.slidePrev();
                }
            });

            // Auto advance video for visible carousel
            function handleSlideAdvance2($carousel) {
                el.find('.owl-item:not(.active) video').each(function () {
                    this.pause();
                });

                let $activeItem = $carousel.find('.owl-item.active');
                let $video = $activeItem.find('video');

                // Clean up previous bindings
                el.find('video').off('.autoadvance');

                if ($video.length) {
                    $video.off('.autoadvance').on('ended.autoadvance', function () {
                        $carousel.trigger('next.owl.carousel');
                        swiperT.slideNext();

                        clearTimeout(timeOut);
                        timeOut = setTimeout(function () {
                            el.find('.owl-item:not(.active) video').each(function () {
                                this.currentTime = 0;
                            });
                            el.find('.owl-item.active video').get(0)?.play();
                        }, 800);
                    });

                    $video.get(0)?.play();
                }
            }

            // Pause video on hover
            el.find('.swiper-desc .body-xl').on('mouseenter', function () {
                el.find('.owl-carousel:visible .owl-item.active video').get(0)?.pause();
            });

            el.find('.swiper-desc .body-xl').on('mouseleave', function () {
                el.find('.owl-carousel:visible .owl-item.active video').get(0)?.play();
            });
        });
    }

    setTimeout(() => {
        grid_text_random();
        watch_video();
        ai_ar();
        grid_3();
        featured_products();
        background_video();
        why_rayneo();
        specs_slider();
        feedbacks();
        bg_details();
        irl();
        subscription();

        watch_video_height()
        gtre_wrap();
        fp_wrap();
        why_rayneo_lines();
        subscription_image();
        feedbacks_clamp();
    }, 500);


    /* HEADER --------------------------------------------------------------- */

    if ($('.new-ab').length) {
        $('.new-ab .swiper-container').each(function () {
            new Swiper($(this)[0], {
                    direction: 'vertical',
                    effect: 'slide',
                    slidesPerView: 1,
                    loop: true,
                    allowTouchMove: true,
                    autoplay: {
                        delay: 3000,
                    }
                });
        });

        function updateCountdown() {
            $('.countdown').each(function () {
                let $this = $(this);
                let dateStr = $this.data('date'); // "30/08/2025 12:00:00"

                // Parse manually: dd/mm/yyyy hh:mm:ss
                let [datePart, timePart] = dateStr.split(' ');
                let [dd, mm, yyyy] = datePart.split('/').map(Number);
                let [hh, min, ss] = timePart.split(':').map(Number);

                // Create valid date object (months are 0-indexed!)
                let targetDate = new Date(yyyy, mm - 1, dd, hh, min, ss);

                // Check validity
                if (isNaN(targetDate.getTime())) {
                    console.warn('Invalid date:', dateStr);
                    return;
                }

                let now = new Date();
                let diff = targetDate - now;

                if (diff <= 0) {
                    $this.find('.countdown-days').text("00");
                    $this.find('.countdown-hrs').text("00");
                    $this.find('.countdown-mins').text("00");
                    $this.find('.countdown-secs').text("00");
                    return;
                }

                let days = Math.floor(diff / (1000 * 60 * 60 * 24));
                let hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
                let minutes = Math.floor((diff / (1000 * 60)) % 60);
                let seconds = Math.floor((diff / 1000) % 60);

                $this.find('.countdown-days').text(days.toString().padStart(2, '0'));
                $this.find('.countdown-hrs').text(hours.toString().padStart(2, '0'));
                $this.find('.countdown-mins').text(minutes.toString().padStart(2, '0'));
                $this.find('.countdown-secs').text(seconds.toString().padStart(2, '0'));
            });
        }

        if ($('.mm-1').length) {
            let acc = $('.mm-1').find('.accordion-item').first();
            acc.find('.accordion-button').removeClass('collapsed');
            acc.find('.accordion-button').attr('aria-expanded', 'true');
            acc.find('.accordion-collapse').addClass('show');
            acc.find('.mm-nav a').first().addClass('active');

            let seen = {};

            $('.mm-1 [data-prod]').each(function () {
                let val = $(this).attr('data-prod');
                if (seen[val]) 
                    $(this).remove();
                else 
                    seen[val] = true;
            });
        }

        if ($('#accordion-main-inner').length) {
            $('#accordion-main-inner .accordion-item').each(function () {
                let seen = {};

                $(this).find('[data-prod]').each(function () {
                    let val = $(this).attr('data-prod');
                    if (seen[val]) {
                        $(this).remove();
                    } else {
                        seen[val] = true;
                    }
                });
            });
        }

        updateCountdown();
        setInterval(updateCountdown, 1000);
    }

    if ($('.mixed-sections').length) {

        let swiper_4;
        if ($('.mixed-sections .section-4').length) {
            let el = $('.mixed-sections .section-4');

            swiper_4 = new Swiper(el.find('.swiper-container')[0], {
                direction: 'vertical',
                effect: 'slide',
                slidesPerView: 1,
                loop: true,
                speed: 800,
                allowTouchMove: false
            });
        }

        const container = $('.mixed-track');
        const sections = $('.sections');

        let segments = [];
        let totalScrollHeight = 0;
        let currentIndex = 0;
        let isSliding = false;

        sections.each(function () {
            let contentVH = parseFloat($(this).data('scroll-length')) || 100;
            let contentPX = (contentVH / 100) * window.innerHeight;

            $(this).css('height', `${contentVH}vh`);

            segments.push({
                start: totalScrollHeight,
                hold: contentPX
            });

            totalScrollHeight += contentPX;
        });

        $('.mixed-sections').css('height', totalScrollHeight + 'px');

        $(window).on('scroll', function () {
            mixed_sections();

            /* mixed_section_1(segments); */
        });

        let section_1_slide = false;

        function mixed_sections() {
            if (isSliding) return;

            let scrollY = scrolledPixels($('.mixed-sections'));
            let seg = segments[currentIndex];
            let segEndHold = seg.start + seg.hold;

            let section_1 = $('.mixed-sections .section-1');

            if (!section_1_slide) {
                if (visiblePercent(section_1) >= 10) {
                    if (!section_1.data('triggered')) {
                        section_1.data('triggered', true);
                        section_1.data('completed', false);

                        const video = section_1.find('video:visible').get(0);

                        if (video) {
                            video.play();
                        }

                        setTimeout(() => {
                            section_1.find('.container').fadeIn();
                            section_1.data('completed', true);
                        }, 1000);
                    }
                }
                else {
                    section_1_slide = false;

                    section_1.data('triggered', false);
                    section_1.data('completed', false);

                    section_1.find('.container').hide();

                    let vid_1 = section_1.find('video:visible').get(0);
                    vid_1.currentTime = 0;
                }
            }

            function slideTo(nextIndex) {

                section_1.data('completed', false);
                section_1.data('triggered', false);

                section_1_slide = true;
                
                setTimeout(() => {
                    section_1.find('.container').hide();
                    let vid_1 = section_1.find('video:visible').get(0);
                    vid_1.currentTime = 0;
                }, 300);

                isSliding = true;

                container.css('transform', `translateX(-${nextIndex * window.innerWidth}px)`);

                setTimeout(() => {
                    currentIndex = nextIndex;
                    isSliding = false;

                    let sections = $('.mixed-sections .sections');

                    let visibleSection = sections.eq(currentIndex);

                    if (visibleSection.hasClass('section-1')) {
                        if (!visibleSection.data('triggered')) {
                            visibleSection.data('triggered', true);
                            visibleSection.data('completed', false);

                            section_1_slide = false;

                            const video = visibleSection.find('video:visible').get(0);

                            if (video) {
                                video.play();
                            }

                            setTimeout(() => {
                                visibleSection.find('.container').fadeIn();

                                visibleSection.data('completed', true);
                            }, 200);
                        }
                    } else {
                        let sec1 = $('.mixed-sections .section-1');

                        if (sec1.data('triggered') && sec1.data('completed')) {
                            sec1.data('triggered', false);
                            sec1.data('completed', false);

                            sec1.find('.container').hide();
                        }
                    }

                    if (visibleSection.hasClass('section-2')) {
                        if (!visibleSection.data('triggered')) {
                            visibleSection.data('triggered', true);
                            visibleSection.data('completed', false);

                            const video = visibleSection.find('video:visible').get(0);

                            video.play();

                            video.addEventListener('ended', function() {
                                visibleSection.data('completed', true);
                            });

                            visibleSection.find('.title-wrapper').css('opacity', '1');

                            setTimeout(() => {
                                visibleSection.find('.title-wrapper').addClass('active');
                            }, 1000);

                            setTimeout(() => {
                                visibleSection.find('.body-wrapper').addClass('active');
                            }, 1500);
                        }

                        let lastScrollSection2 = 0;
                        $(window).on("scroll", function () {
                            if (visibleSection.find('.body-wrapper').hasClass('active')) {
                                let currentScroll = $(this).scrollTop();

                                if (currentScroll > lastScrollSection2) {
                                    visibleSection.find('.body-1').hide();
                                    visibleSection.find('.body-2').fadeIn();

                                    visibleSection.find('.background-image').css('opacity', '1');
                                    visibleSection.find('.image-wrapper').addClass('active'); 
                                } 
                                else if (currentScroll < lastScrollSection2) {
                                    visibleSection.find('.body-1').fadeIn();
                                    visibleSection.find('.body-2').hide();

                                    visibleSection.find('.background-image').css('opacity', '0');
                                    visibleSection.find('.image-wrapper').removeClass('active'); 
                                }

                                lastScrollSection2 = currentScroll <= 0 ? 0 : currentScroll;
                            }
                        });
                    } 
                    else {
                        let sec2 = $('.mixed-sections .section-2');

                        if (sec2.data('triggered') && sec2.data('completed')) {
                            sec2.data('triggered', false);
                            sec2.data('completed', false);

                            sec2.find('.title-wrapper').css('opacity', '0').removeClass('active');
                            sec2.find('.body-wrapper').removeClass('active');
                            sec2.find('.image-wrapper').removeClass('active'); 
                            sec2.find('.background-image').css('opacity', '0');

                            sec2.find('.body-1').show();
                            sec2.find('.body-2').hide();
                        }
                    }


                    if (visibleSection.hasClass('section-3')) {
                        if (!visibleSection.data('triggered')) {
                            visibleSection.data('triggered', true);
                            visibleSection.data('completed', false);

                            const video = visibleSection.find('video:visible').get(0);

                            if (video) {
                                video.play();

                                visibleSection.find('.title-wrapper').addClass('active');

                                setTimeout(() => {
                                    visibleSection.find('.body-wrapper').addClass('active');

                                    visibleSection.data('completed', true);
                                }, 2500);
                            }

                            visibleSection.find('.title-wrapper').css('opacity', '1');
                        }
                    } else {
                        let sec3 = $('.mixed-sections .section-3');

                        if (sec3.data('triggered') && sec3.data('completed')) {
                            sec3.data('triggered', false);
                            sec3.data('completed', false);

                            sec3.find('.title-wrapper').css('opacity', '0').removeClass('active');
                            sec3.find('.body-wrapper').removeClass('active');
                        }
                    }


                    if (visibleSection.hasClass('section-4') && !visibleSection.data('triggered')) {
                        visibleSection.data('triggered', true);

                        setTimeout(() => {
                            visibleSection.find('.container').css('opacity', '1');
                        }, 500);

                        setTimeout(() => {
                            setInterval(function() {
                                $('.mixed-sections .section-4 .stacks .stack').each(function() {
                                    let match = $(this).attr("class").match(/stack-(\d+)/);
                                    if (match) {
                                        let current = parseInt(match[1]);
                                        let next = current - 1; 
                                        if (next === 0) next = 12;

                                        if (next === 8) {
                                            $(this).css("transition", "none");
                                            $(this).removeClass("stack-" + current).addClass("stack-" + next);
                                            $(this).css("opacity", 0);
                                            setTimeout(() => {
                                                $(this).css({
                                                    transition: "opacity 1s ease",
                                                    opacity: 1
                                                });
                                            }, 20);
                                        }
                                        else if (next === 11) {
                                            $(this).css("transition", "none");
                                            $(this).removeClass("stack-" + current).addClass("stack-" + next);
                                            $(this).css("opacity", 0);
                                            setTimeout(() => {
                                                $(this).css({
                                                    transition: "opacity 1s ease, top 1s ease, transform 1s ease",
                                                    opacity: 1
                                                });
                                            }, 20);
                                        }
                                        else {
                                            $(this).css("transition", "top 1s ease, transform 1s ease, opacity 1s ease");
                                            $(this).removeClass("stack-" + current).addClass("stack-" + next);
                                        }
                                    }
                                });
                                swiper_4.slideNext();
                            }, 2000);
                        }, 800);
                    }

                }, 700);
            }

            if (scrollY >= segEndHold && currentIndex < sections.length - 1) {
                slideTo(currentIndex + 1);
            }

            if (scrollY < seg.start && currentIndex > 0) {
                slideTo(currentIndex - 1);
            }
        }
    }

    header();
    grid_4();
    play_video();
    full_video();
});

$(window).scroll(function () {
    grid_text_random();
    watch_video();
    ai_ar();
    grid_3();
    featured_products();
    background_video();
    why_rayneo();
    specs_slider();
    feedbacks();
    bg_details();
    irl();
    subscription();

    header();
    grid_4();
    play_video();
    full_video();

});

$(window).resize(function () {
    gtre_wrap();
    fp_wrap();
    watch_video_height();
    why_rayneo_lines();
    subscription_image();
    feedbacks_clamp();
});

let lastScrollTop = 0;
function header() {

    if (!$('.header-group').hasClass('product-header')) {
        if ($(window).scrollTop() >= 10)
            $('.header-group').addClass('scrolled');
        else
            $('.header-group').removeClass('scrolled');
    }
    
    if (!$('.new-ab').hasClass('hidden')) {
        let currentScroll = $(window).scrollTop();
        let abHeight = $('.new-ab').length ? $('.new-ab').outerHeight() : 0;

        if (currentScroll > lastScrollTop) 
            $('.header-group').css('transform', `translateY(-${abHeight}px)`);
        else if (currentScroll < lastScrollTop)
            $('.header-group').css('transform', `translateY(0)`);

        lastScrollTop = currentScroll;
    }
}

$('.new-ab .ab-hide').on('click', function() {
    $('.new-ab').addClass('hidden');

    let abHeight = $('.new-ab').length ? $('.new-ab').outerHeight() : 0;
    $('.header-group').css('transform', `translateY(-${abHeight}px)`);

    let headerHeight = $('.header-group').outerHeight();

    $('.nav-mobile').css('height', `${($(window).height() - headerHeight)+abHeight}px`);
});

/* function moving_banner_mobile(event) {
    $('.moving-banner').each(function() {
        let el = $(this).find('.mobile');

        const maxOffset = 20;
    
        let gamma = event.gamma || 0;
        let beta = event.beta || 0;

        gamma = Math.max(-maxOffset, Math.min(maxOffset, gamma));
        beta = Math.max(-maxOffset, Math.min(maxOffset, beta));

        el.find('img').css('transform', `translate(${gamma}px, ${beta}px)`);
        el.find('.bg-text').css('transform', `translate(${-gamma}px, ${-beta}px)`);
    });
}

$('.moving-banner .btn-enable').on('click', function() {
    $(this).parents('.moving-banner').find('.overlay').remove();

    if (typeof DeviceOrientationEvent !== 'undefined' &&
            typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission()
        .then(response => {
            if (response === 'granted') {
                window.addEventListener('deviceorientation', moving_banner_mobile);
            } 
            else {
                console.log('Motion permission was denied.');
            }
        })
        .catch(err => {
            console.log('Error requesting motion permission.');
            console.error(err);
        });
    } 
    else {
        window.addEventListener('deviceorientation', moving_banner_mobile);
    }
}); */

let ticking_movingBanner = false;

$('.moving-banner').on('mousemove', function (e) {
    if (!ticking_movingBanner) {
        window.requestAnimationFrame(function () {
            moving_banner(e);
            ticking_movingBanner = false;
        });
        ticking_movingBanner = true;
    }
});

$('.moving-banner').on('mouseleave', function () {
    $('.moving-banner .desktop .elements').each(function () {
        const $this = $(this);
        $this.find('img').css('transform', '');
        $this.find('.bg-text:not(:has(br))').css('transform', 'translate(-50%, -50%)');
        $this.find('.bg-text:has(br)').css('transform', '');
    });
});

function moving_banner(e) {
    $('.moving-banner .desktop .elements').each(function () {
        const $this = $(this);
        const offset = $this.offset();
        const width = $this.width();
        const height = $this.height();

        const centerX = offset.left + width / 2;
        const centerY = offset.top + height / 2;

        const dx = e.pageX - centerX;
        const dy = e.pageY - centerY;

        const distance = Math.min(10, Math.sqrt(dx * dx + dy * dy));
        const angle = Math.atan2(dy, dx);

        const moveX = Math.cos(angle) * distance;
        const moveY = Math.sin(angle) * distance;

        $this.find('img').css('transform', `translate(${moveX}px, ${moveY}px)`);
        $this.find('.bg-text:not(:has(br))').css('transform', `translate(calc(-50% + ${-moveX}px), calc(-50% + ${-moveY}px))`);
        $this.find('.bg-text:has(br)').css('transform', `translate(${-moveX}px, ${-moveY}px)`);
    });
}

function grid_text_random() {
    if ($('.gtre').length) {
        $('.gtre').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50 && !el.data('triggered')) {
                el.data('triggered', true);

                el.find('.wrap-title').addClass('active');
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');

                setTimeout(() => {
                    el.find('.decrypt').each(function() {
                        decrypt($(this));
                    });
                }, 1000);
            }
        });
    }
}

function decrypt(el) {
    el.find('span').each(function(i) {
        const $span = $(this);
        const original = $span.data('i');
        const chars = '!@#$%^&*()_+-=[]{}|;:",.<>?/\\~`';

        let iterations = 0;
        const maxIterations = (i + 1) * 3;

        const interval = setInterval(() => {
            const randomChar = chars[Math.floor(Math.random() * chars.length)];
            $span.text(randomChar);

            iterations++;
            if (iterations >= maxIterations) {
                clearInterval(interval);
                $span.text(original);
            }
        }, 60);
    });
}

function gtre_wrap() {
    if ($('.gtre').length) {
        $('.gtre').each(function () {
            let $wraps = $(this).find('.wraps');
            let $wrap = $(this).find('.wrap');
            let $text = $(this).find('.wrap-text');
            let maxHeight = 0;

            $wrap.css('height', 'auto');

            $wrap.each(function () {
                let thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            $wraps.height(maxHeight);
            $wrap.height(maxHeight);
            $text.height(maxHeight);
        });
    }
}

function visiblePercent($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    let distanceFromTop = elementOffset - scrollTop;
    let visiblePercent = (windowHeight - distanceFromTop) / elementHeight * 100;

    visiblePercent = Math.max(0, Math.min(100, visiblePercent));

    return visiblePercent;
}

function sectionPercent($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();

    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();

    let scrollPercentage = Math.min(100, Math.max(0, ((viewportHeight - elementTop) / elementHeight) * 100));

    return scrollPercentage;
}

function scrolledPixels($element) {
    let scrollTop = $(window).scrollTop();
    let windowHeight = $(window).height();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    // Amount of element already scrolled into view
    let scrolled = scrollTop + windowHeight - elementOffset;

    // Clamp between 0 and elementHeight
    scrolled = Math.max(0, Math.min(elementHeight, scrolled));

    return scrolled;
}

$('.gtre .desktop .wrap').on('click', function (e) {
    e.stopPropagation();

    let $wraps = $(this).parents('.desktop').find('.wraps');
    let $wrap = $(this).parent();
    let index = $(this).data('idx');

    $wraps.find('.wrap-text').fadeOut(500);

    $wraps.each(function () {
        $(this).find('.wrap[data-idx="1"]').css('left', '0%');
        $(this).find('.wrap[data-idx="2"]').css('left', '25%');
        $(this).find('.wrap[data-idx="3"]').css('left', '50%');
        $(this).find('.wrap[data-idx="4"]').css('left', '75%');
    });

    if (index === 1) {
        $wrap.find('.wrap[data-idx="2"]').css('left', '75%');
        $wrap.find('.wrap[data-idx="3"]').css('left', '100%');
        $wrap.find('.wrap[data-idx="4"]').css('left', '125%');
    } else if (index === 2) {
        $wrap.find('.wrap[data-idx="3"]').css('left', '125%');
        $wrap.find('.wrap[data-idx="4"]').css('left', '150%');
    } else if (index === 3) {
        $wrap.find('.wrap[data-idx="1"]').css('left', '-50%');
        $wrap.find('.wrap[data-idx="2"]').css('left', '-25%');
        $wrap.find('.wrap[data-idx="3"]').css('left', '0%');
    } else if (index === 4) {
        $wrap.find('.wrap[data-idx="1"]').css('left', '-50%');
        $wrap.find('.wrap[data-idx="2"]').css('left', '-25%');
        $wrap.find('.wrap[data-idx="3"]').css('left', '0%');
        $wrap.find('.wrap[data-idx="4"]').css('left', '25%');
    }

    $(this).next('.wrap-text').fadeIn(500);
});

$('.gtre .mobile .wrap').on('click', function (e) {
    e.stopPropagation();

    let $wraps = $(this).parents('.mobile').find('.wraps');
    let $wrap = $(this).parent();
    let index = $(this).data('idx');

    $wraps.find('.wrap-text').fadeOut(500);

    $wraps.each(function () {
        $(this).find('.wrap[data-idx="1"]').css('left', '0%');
        $(this).find('.wrap[data-idx="2"]').css('left', '50%');
        $(this).find('.wrap[data-idx="2"]').addClass('last');
    });

    if (index === 1) {
        $wrap.find('.wrap[data-idx="1"]').css('left', '0%');
        $wrap.find('.wrap[data-idx="2"]').css('left', '100%');
    } else if (index === 2) {
        $wrap.find('.wrap[data-idx="1"]').css('left', '-50%');
        $wrap.find('.wrap[data-idx="2"]').css('left', '0%');

        $(this).removeClass('last');
    }

    $(this).next('.wrap-text').fadeIn(500);
});

$('.gtre').on('click', function () {
    let $wrapsDesktop = $(this).find('.desktop .wraps');
    $wrapsDesktop.find('.wrap-text').fadeOut(500);

    $wrapsDesktop.each(function () {
        $(this).find(`.wrap[data-idx="1"]`).css('left', '0%');
        $(this).find(`.wrap[data-idx="2"]`).css('left', '25%');
        $(this).find(`.wrap[data-idx="3"]`).css('left', '50%');
        $(this).find(`.wrap[data-idx="4"]`).css('left', '75%');
    });

    let $wrapsMobile = $(this).find('.mobile .wraps');
    $wrapsMobile.find('.wrap-text').fadeOut(500);

    $wrapsMobile.each(function () {
        $(this).find(`.wrap[data-idx="1"]`).css('left', '0%');
        $(this).find(`.wrap[data-idx="2"]`).css('left', '50%');
        $(this).find(`.wrap[data-idx="2"]`).addClass('last');
    });
});

function watch_video_height() {
    if ($('.watch-video').length) {
        $('.watch-video').each(function () {
            let el = $(this);

            let height = el.find('.content').height();
            el.find('.content-up').css('height', `${height}px`);
        });
    }
}

function watch_video() {
    if ($('.watch-video').length) {
        $('.watch-video').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 80) {
                el.find('.content').addClass('active');
            } else {
                el.find('.content').removeClass('active');
            }
        });
    }
}

$('.watch-video .toggle-video').on('click', function () {
    let $video = $(this).parents('.watch-video').find('.sticky video');

    if ($video[0].paused) {
        $video[0].play();
        $(this).find('i').removeClass('fa-play').addClass('fa-pause');
    } else {
        $video[0].pause();
        $(this).find('i').removeClass('fa-pause').addClass('fa-play');
    }
});

$('.watch-video .btn-watch').on('click', function () {
    $(this).parents('.watch-video').find('.video-wrapper').fadeIn(500);

    let $video_bg = $(this).parents('.watch-video').find('.sticky video');
    $video_bg[0].pause();
    $('.toggle-video i').removeClass('fa-pause').addClass('fa-play');

    let $video = $(this).parents('.watch-video').find('.video-wrapper video');
    $video[0].play();
});

$('.watch-video .close-video, .watch-video .overlay').on('click', function () {
    $(this).parents('.watch-video').find('.video-wrapper').fadeOut(500);

    let $video_bg = $(this).parents('.watch-video').find('.sticky video');
    $video_bg[0].play();
    $('.toggle-video i').removeClass('fa-play').addClass('fa-pause');

    let $video = $(this).parents('.watch-video').find('.video-wrapper video');
    $video[0].pause();
});

function background_video() {
    if ($('.background-video').length) {
        $('.background-video').each(function () {
            let el = $(this);
            let show = el.find('.show-up');

            if (sectionPercent(el) > 80) {
                el.find('.overlay').delay(500).fadeOut(500);
                show.addClass('show');
            }
        });
    }
}

function why_rayneo() {
    if ($('.why-rayneo').length) {
        $('.why-rayneo').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 80) {
                el.find('.wrap-text').addClass('active');

                el.find('.text-line').each(function (index) {
                    const $line = $(this);
                    setTimeout(function () {
                        $line.css('opacity', '1');
                    }, index * 1000);
                });
            }
        });
    }
}

function why_rayneo_lines() {
    if ($('.why-rayneo').length) {
        $('.why-rayneo').each(function () {
            $el = $(this).find('.body-xl');
            let words = '';

            $lines = $el.find('.text-line');

            if ($lines.length > 0) {
                $el.html('');
                $lines.each(function () {
                    $el.append($(this).text() + ' ');
                });
                words = $el.text().split(' ');
            } else {
                words = $el.text().split(' ');
            }

            $el.html('');

            let line = $('<span></span>');
            $el.append(line);

            for (let i = 0; i < words.length; i++) {
                const testLine = line.clone().text(line.text() + (line.text() ? ' ' : '') + words[i]);
                $el.append(testLine);

                if (testLine.height() > line.height()) {
                    line = $('<span></span>').text(words[i]);
                    $el.append(line);
                } else {
                    line.text(testLine.text());
                }

                testLine.remove();
            }

            $el.find('span').each(function () {
                $(this).wrap(`<div class="text-line"></div>`);
            });
        });
    }
}

function feedbacks() {
    if ($('.feedbacks').length) {
        $('.feedbacks').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50) {
                el.find('.wrap-title').addClass('active');
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');
            }
        });
    }
}

function bg_details() {
    if ($('.bg-details').length) {
        $('.bg-details').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50) {
                el.find('.wrap-title').addClass('active');
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');
            }
        });
    }
}

function subscription() {
    if ($('.subscription').length) {
        $('.subscription').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50) {
                el.find('.wrap-title').addClass('active');
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');
            }
        });
    }
}

function subscription_image() {
    if ($('.subscription').length) {
        $('.subscription').each(function () {
            let el = $(this);
            const $images = el.find('.images');
            
            $images.each(function() {
                $image = $(this).find('img');
                const imageCount = $image.length;

                if (imageCount === 0) return;

                const imageW = $image.first().outerWidth();
                const offset = imageW / 2;

                $image.each(function (index) {
                    $(this).css('transform', `translateX(${-index * offset}px)`);
                });

                const totalWidth = imageW + (imageCount - 1) * offset;
                el.find('.images').css('width', `${totalWidth}px`);
            })
        });
    }
}

function specs_slider() {
    if ($('.specs-slider').length) {
        $('.specs-slider').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50) {
                el.find('.wrap-title').addClass('active');
                el.find('.wraps').addClass('active');
            }
        });
    }
}

function feedbacks_clamp() {
    if ($('.feedbacks').length) {
        $('.feedbacks').each(function () {
            let el = $(this);

            el.find('.clamp').each(function () {
                let clampEl = $(this);

                if (!clampEl.is(':visible')) {
                    let hiddenParents = clampEl.parents(':hidden');
                    hiddenParents.each(function () {
                        $(this).data('original-style', $(this).attr('style') || '');
                        $(this).css({
                            visibility: 'hidden',
                            display: 'block',
                            position: 'absolute'
                        });
                    });

                    let h = clampEl.height();
                    clampEl.attr('data-height', h);
                    clampEl.css('height', `${h}px`);

                    hiddenParents.each(function () {
                        let originalStyle = $(this).data('original-style');
                        if (originalStyle === '') {
                            $(this).removeAttr('style');
                        } else {
                            $(this).attr('style', originalStyle);
                        }
                    });
                } else {
                    let h = clampEl.height();
                    clampEl.attr('data-height', h);
                    clampEl.css('height', `${h}px`);
                }
            });
        });
    }
}

$(document).on('click', '.feedbacks .slide-nav button', function () {
    let el = $(this).parents('.feedbacks');
    let total = parseInt($(this).parent().data('pages'), 10);

    let currentPage = parseInt($(this).attr('data-page'), 10);
    let nextPage = currentPage;

    if ($(this).hasClass('owl-next')) {
        nextPage = currentPage < total ? currentPage + 1 : 1;
    } else {
        nextPage = currentPage > 1 ? currentPage - 1 : total;
    }

    el.find('.owl-next').attr('data-page', nextPage);
    el.find('.owl-prev').attr('data-page', nextPage);
    el.find('.wraps').hide();
    el.find(`.wraps[data-page="${nextPage}"]`).css('display', 'flex');
});

$('.feedbacks .wrap').on('click', function() {
    let el = $(this).parents();

    el.find('.clamp').each(function() {
        currentHeight = $(this).data('height');
        $(this).css('height', `${currentHeight}px`);
    });

    el.find('.clamp').css('display', '-webkit-box');

    let clamp = $(this).find('.clamp');
    let setHeight = $(this).find('.hidden-text').height();

    clamp.height(`${setHeight}px`);
    clamp.css('display', 'block');
});

function ai_ar() {
    if ($('.ai-ar').length) {
        $('.ai-ar').each(function() {
           let el = $(this);
           
           el.find('video').each(function() {
                this.pause();
           });

           if (sectionPercent(el) > 50 && !el.data('triggered')) {
                el.data('triggered', true);
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');

                setTimeout(() => {
                    countUp(el.find('.count-up'));
                }, 500);
            }
        });
    }
}

$('.ai-ar .desktop .wraps-item:last-child .wrap').on('mouseenter', function(e) {
    $(this).addClass('stretch').siblings().removeClass('stretch');

    $('.ai-ar').find('video').each(function() {
        this.pause();
        this.currentTime = 0;
    });

    if ($(this).hasClass('stretch')) {
        $(this).find('video').each(function() {
            this.play();
        });
    }
}).on('mouseleave', function() {
    let el = $('.ai-ar');

    el.find('video').each(function() {
        this.pause();
        this.currentTime = 0;
    });

    el.find('.wrap').removeClass('stretch');
});

$('.ai-ar .mobile .wrap').on('mouseenter', function(e) {
    $('.ai-ar').find('video').each(function() {
        this.pause();
        this.currentTime = 0;
    });

    $('.ai-ar .video-1').css('opacity', '0');

    $(this).css('width', '55%');
    $(this).siblings().css('width', '45%');

    $(this).find('.video-1').css('opacity', '1');

    $(this).find('video').each(function() {
        this.play();
    });
}).on('mouseleave', function() {
    let el = $('.ai-ar');

    el.find('video').each(function() {
        this.pause();
        this.currentTime = 0;
    });

    el.find('.wrap .video-1').css('opacity', '0');
    el.find('.wrap').css('width', '50%');
});

function grid_3() {
    if ($('.grid-3').length) {
        $('.grid-3').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50) {
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');
            }
        });
    }
}

$('.grid-3 .desktop .wrap').on('click', function(e) {
    e.stopPropagation();

    $(this).parents('.grid-3 .desktop').find('.wrap').removeClass('enlarge').removeClass('shrink');
    $(this).parents('.grid-3 .desktop').find('.shades').css({
        'position': 'relative',
        'opacity': '1'
    });
    $(this).parents('.grid-3 .desktop').find('.hovered').hide();

    $(this).addClass('enlarge').siblings().addClass('shrink');

    $(this).find('.shades').css({
        'position': 'absolute',
        'opacity': '0'
    });
    $(this).find('.hovered').fadeIn();

    let index = $(this).data('idx');

    $('.featured-products').hide();
    $(`.featured-products[data-grid="${index}"]`).fadeIn();
    fp_wrap();
});

let defaultHeight = $('.grid-3 .mobile .wraps').innerHeight();
$('.grid-3 .mobile .wraps').on('click', function(e) {
    e.stopPropagation();

    $('.grid-3 .mobile .wraps').css('height', `${defaultHeight}px`);
    $(this).parents('.grid-3 .mobile').find('.shades').css({
        'position': 'relative',
        'opacity': '1'
    });
    $(this).parents('.grid-3 .mobile').find('.hovered').hide();

    $(this).css('height', 'auto');

    $(this).find('.shades').css({
        'position': 'absolute',
        'opacity': '0'
    });
    $(this).find('.hovered').fadeIn();

    let index = $(this).data('idx');

    $('.featured-products').hide();
    $(`.featured-products[data-grid="${index}"]`).fadeIn();
    fp_wrap();
});

$('.grid-3').on('click', function() {
    $(this).find('.wrap').removeClass('enlarge').removeClass('shrink');
    $(this).find('.shades').css({
        'position': 'relative',
        'opacity': '1'
    });
    $(this).find('.hovered').hide();
    $('.featured-products').slideUp();

    $('.grid-3 .mobile .wraps').css('height', `${defaultHeight}px`);
});

$('.featured-products .btn-collapse').on('click', function() {
    $('.grid-3').find('.wrap').removeClass('enlarge').removeClass('shrink');
    $('.grid-3').find('.shades').css({
        'position': 'relative',
        'opacity': '1'
    });
    $('.grid-3').find('.hovered').hide();
    $('.featured-products').slideUp();
});

function fp_wrap() {
    if ($('.featured-products').length) {
        $('.featured-products').each(function () {
            let $wrap = $(this).find('.wrap');
            let maxHeight = 0;

            $wrap.css('height', 'auto');

            $wrap.each(function () {
                let thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            $wrap.height(maxHeight);
        });
    }
}

function featured_products() {
    if ($('.featured-products').length) {
        $('.featured-products:visible').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 20 && !el.data('triggered')) {
                el.data('triggered', true);
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');

                setTimeout(() => {
                    el.find('.decrypt').each(function() {
                        decrypt($(this));
                    });
                }, 1000);
            }
        });
    }
}

function countUp(el) {
    el.each(function () {
        let $this = $(this);
        let rawText = $this.data('max');

        let match = rawText.match(/^([\d,]+)(.*)$/);
        if (!match) return;

        let rawNumber = match[1];
        let suffix = match[2];

        let target = parseInt(rawNumber.replace(/,/g, ''));

        $this.text('0' + suffix);

        if (target <= 10) {
            let delay = 30;

            function countSlowly(step) {
                if (step > target) return;

                setTimeout(function () {
                    $this.text(step.toLocaleString() + suffix);
                    delay *= 1.4;
                    countSlowly(step + 1);
                }, delay);
            }

            countSlowly(1);
        } 
        else {
            let preTarget = target - 10;

            $({ countNum: 0 }).animate(
                { countNum: preTarget },
                {
                    duration: 2000,
                    easing: 'swing',
                    step: function () {
                        $this.text(Math.floor(this.countNum).toLocaleString() + suffix);
                    },
                    complete: function () {
                        let current = preTarget;
                        let delay = 30;

                        function countSlowly(step) {
                            if (step > 10) return;

                            setTimeout(function () {
                                current++;
                                $this.text(current.toLocaleString() + suffix);
                                delay *= 1.4;
                                countSlowly(step + 1);
                            }, delay);
                        }

                        countSlowly(1);
                    }
                }
            );
        }
    });
}

function irl() {
    if ($('.irl').length) {
        $('.irl').each(function() {
            let el = $(this);

            if (sectionPercent(el) > 50 && !el.data('triggered')) {
                el.data('triggered', true);

                setTimeout(() => {
                    el.find('video').addClass('active');
                    el.find('.wrap-title').addClass('active');
                    el.find('.irl-text').addClass('active');
                }, 1000);

                setTimeout(() => {
                    el.find('.main').css({
                        'animation': 'main 40s linear infinite',
                        'pointer-events': 'auto'
                    });
                    el.find('.duplicate').css({
                        'animation': 'duplicate 40s linear infinite reverse',
                        'opacity': '1',
                        'pointer-events': 'auto'
                    });

                }, 3000);
            }
        });
    }
}

$('.irl video').on('mouseenter', function () {
    let el = $(this).closest('.irl');
    let $this = $(this);
    let index = $this.attr('data-index');

    el.find('video').css('opacity', '.5');

    el.find('.main').css('animation-play-state', 'paused');
    el.find('.duplicate').css('animation-play-state', 'paused');

    pauseAllVideo();

    let main = el.find(`.main video[data-index="${index}"]`);
    let dupl = el.find(`.duplicate video[data-index="${index}"]`);

    main.css('opacity', '1');
    dupl.css('opacity', '1');

    main[0].play();
    dupl[0].play();

}).on('mouseleave', function () {
    let el = $(this).closest('.irl');
    el.find('video').css('opacity', '1');

    el.find('.main').css('animation-play-state', 'running');
    el.find('.duplicate').css('animation-play-state', 'running');

    pauseAllVideo();
});

function pauseAllVideo() {
    let el = $('.irl');

    for (let i = 1; i <= 13; i++) {
        let m = el.find(`.main video[data-index="${i}"]`)[0];
        let d = el.find(`.duplicate video[data-index="${i}"]`)[0];

        if (m && d) {
            m.pause();
            d.pause();

            d.currentTime = m.currentTime;

            setTimeout(() => {
                m.currentTime = d.currentTime;
            }, 100);
        }
    }
}

$('.new-footer .switch-currency').on('change', function() {
    let val = $(this).val().split(' | ');
    let currentUrl = new URL(window.location.href);

    currentUrl.searchParams.set("country", val[0]);
    currentUrl.searchParams.set("currency", val[1]);

    window.location.href = currentUrl.toString();
});

$('.header .nav-item').on('mouseover', function() {

    $('.header .nav-items').find('.underline').css('transform', 'scale(0)');
    $(this).find('.underline').css('transform', 'scale(1)');

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.drop').hide();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop[data-drop="' + dropValue + '"]');
        $drop.show();

        let navItemOffset = $this.offset();
        let navItemWidth = $this.outerWidth();
        let dropWidth = $drop.outerWidth();
        
        let leftPosition = navItemOffset.left + (navItemWidth / 2) - (dropWidth / 2);

        $drop.css({
            'left': leftPosition
        });
    }

    let headerHeight = $('.header-group').outerHeight();
    if ($('.header-group').css('transform') !== 'none') {
        let values = $('.header-group').css('transform').split('(')[1].split(')')[0].split(',');
        let translateY = values[5].trim();
        
        headerHeight = parseFloat(headerHeight) + parseFloat(translateY);
    }

    $('.megamenu.mm-1').css('height', `${$(window).height()-headerHeight}px`);

});

let isMouseOverDrop = false;

$('.header .nav-items').on('mouseleave', function(event) {

    let $navItems = $(this);
    let navItemsOffset = $navItems.offset();
    let navItemsWidth = $navItems.outerWidth();
    let navItemsHeight = $navItems.outerHeight();
    let buffer = 30;

    let extendedLeft = navItemsOffset.left - buffer;
    let extendedRight = navItemsOffset.left + navItemsWidth + buffer;
    let extendedTop = navItemsOffset.top - buffer;
    let extendedBottom = navItemsOffset.top + navItemsHeight + buffer;

    $(document).on('mousemove.navItemsCheck', function(event) {
        let mouseX = event.pageX;
        let mouseY = event.pageY;

        if (mouseX < extendedLeft || mouseX > extendedRight || mouseY < extendedTop || mouseY > extendedBottom) {
            if (!isMouseOverDrop) {
                $('.drop').hide();
                $('.header .nav-items').find('.underline').css('transform', 'scale(0)');
            }
        }
    });
});

$('.header .nav-items').on('mouseenter', function() {
    $(document).off('mousemove.navItemsCheck');
});

$('.drop1').on('mouseenter', function() {
    isMouseOverDrop = true;
});

$('.drop1').on('mouseleave', function() {
    isMouseOverDrop = false;
    $('.header .nav-items').trigger('mouseleave');
});

$('.country-selector').on('click', function() {
    $('.country-selection').fadeIn();
    $('body').css('overflow-y', 'hidden');
});

$('.country-selection .overlay, .country-selection .close-selector').on('click', function() {
    $('.country-selection').fadeOut();
    $('body').css('overflow-y', 'auto');
});

$('.mm-1 .mm-nav a').on('click', function() {
    let prod = $(this).data('col');

    $('.mm-1 .mm-nav a').removeClass('active');
    $(this).addClass('active');

    $('.mm-1 .row-products').hide();
    $('.mm-1 .row-products[data-prod="' + prod + '"]').css('display', 'flex');
});

$('.mm-1-close').on('click', function() {
    $('.header .drop').hide();
});

$('.header .toggle-menu').on('click', function() {

    $('.nav-mobile').toggleClass('open');

    let headerHeight = $('.header-group').outerHeight();
    if ($('.header-group').css('transform') !== 'none') {
        let values = $('.header-group').css('transform').split('(')[1].split(')')[0].split(',');
        let translateY = values[5].trim();
        headerHeight = parseFloat(headerHeight) + parseFloat(translateY);
    }

    $('.nav-mobile').css('height', `${$(window).height() - headerHeight}px`);

    if ($('.nav-mobile').hasClass('open')) {
        $('body').css('overflow-y', 'hidden');

        $('.toggle-menu i').first().hide();
        $('.toggle-menu i').last().css('display', 'inline-block');
    }
    else {
        $('body').css('overflow-y', 'auto');

        $('.toggle-menu i').first().css('display', 'inline-block');
        $('.toggle-menu i').last().hide();

        $('.nav-mobile .mobile-mm').removeClass('active');
    }
});

$(document).on('click', '#accordion-menu .accordion-button.button-main', function (e) {
    const $target = $(e.target);

    if ($target.is('span')) {
        const href = $target.parent('a').attr('href');
        
        window.location.href = href;
        return false;
    }

    const $button = $(this);

    $('#accordion-menu .accordion-button.button-main').not($button).addClass('collapsed');

    if ($button.hasClass('has-mega')) {
        let selector = $button.data('dropmobile');

        $('.nav-mobile .mobile-mm').removeClass('active');
        $(`.nav-mobile .mobile-mm[data-selector="${selector}"]`).addClass('active');
        
        $('#accordion-menu > .accordion-item > .accordion-collapse').removeClass('show');
    }
    else {
        const target = $button.attr('data-bs-target');
        $(target).collapse('toggle');
        $button.toggleClass('collapsed');
    }
});

$(document).on('click', '.accordion.inner .accordion-button:has(span)', function (e) {
    const $button = $(this);
    const target = $button.attr('data-bs-target');
    $(target).collapse('toggle');

    $('.accordion.inner .accordion-button').not($button).addClass('collapsed');
    $button.toggleClass('collapsed'); 
});

$(document).on('click', '.accordion.inner .accordion-button:has(a)', function (e) {
    const href = $(this).find('a').attr('href');
        
    window.location.href = href;

    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
    
});

$('.nav-mobile .mm-header i').on('click', function() {
    $('.nav-mobile .mobile-mm').removeClass('active');
});

$('.nav-mobile .btn-more').on('click', function() {
    $(this).parent().css('max-height', 'none').removeClass('more');
    $(this).hide();
});

/* -------------------------------------------------------------- */

let ticking_productBanner = false;

$('.product-banner').on('mousemove', function (e) {
    if (!ticking_productBanner) {
        window.requestAnimationFrame(function () {
            product_banner(e);
            ticking_productBanner = false;
        });
        ticking_productBanner = true;
    }
});

$('.product-banner').on('mouseleave', function () {
    $('.product-banner .desktop').each(function () {
        const $this = $(this);
        
        $this.find('.object-small').css('transform', '');
        $this.find('.object-large').css('transform', '');
        $this.find('.object-main').css('transform', '');
        $this.find('.title-container').css('transform', '');
    });
});

function product_banner(e) {
    $('.product-banner .desktop').each(function () {
        const $this = $(this);
        const offset = $this.offset();
        const width = $this.width();
        const height = $this.height();

        const centerX = offset.left + width / 2;
        const centerY = offset.top + height / 2;

        const dx = e.pageX - centerX;
        const dy = e.pageY - centerY;

        const distance = Math.min(10, Math.sqrt(dx * dx + dy * dy));
        const angle = Math.atan2(dy, dx);

        const moveX = Math.cos(angle) * distance;
        const moveY = Math.sin(angle) * distance;

        $this.find('.object-small').css('transform', `translate(${-moveX}px, ${-moveY}px)`);
        $this.find('.object-large').css('transform', `translate(${-moveX}px, ${-moveY}px)`);
        $this.find('.object-main').css('transform', `translate(${moveX}px, ${moveY}px)`);
        $this.find('.title-container').css('transform', `translate(${moveX}px, ${moveY}px)`);
    });
}

function play_video() {
    if ($('.play-video').length) {
        $('.play-video').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50 && !el.data('triggered')) {
                el.data('triggered', true);

                el.find('.wrap-title').addClass('active');

                setTimeout(() => {
                    el.find('.video-1:visible').each(function() {
                        this.play();
                    });
                }, 1000);
            }

            el.find('.full-video .video-2').get(0).pause();
            el.find('.full-video .video-2').get(0).currentTime = 0;
        });
    }
}

$('.play-video .video-1').on('click', function() {
    let el = $(this).parents('.play-video');

    el.find('.full-video').fadeIn();
    el.find('.full-video .video-2').get(0).play();

    $('body').css('overflow-y', 'hidden');
});

$('.play-video .close-video, .play-video .overlay').on('click', function() {
    let el = $(this).parents('.play-video');

    el.find('.full-video').fadeOut();
    el.find('.full-video .video-2').get(0).pause();
    el.find('.full-video .video-2').get(0).currentTime = 0;
    
    $('body').css('overflow-y', 'visible');
});

function full_video() {
    if ($('.full-video').length) {
        $('.full-video').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 10 && !el.find('.wrap-title').data('triggered')) {
                el.find('.wrap-title').data('triggered', true);

                el.find('.wrap-title').addClass('active');
            }
            if (sectionPercent(el) > 80 && !el.find('video').data('triggered')) {
                el.find('video').data('triggered', true);

                el.find('video').get(0).play();
            }
        });
    }
}

function grid_4() {
    if ($('.grid-4').length) {
        $('.grid-4').each(function () {
            let el = $(this);

            if (sectionPercent(el) > 50) {
                el.find('.wraps').addClass('active');
                el.find('.wrap').addClass('active');
            }
        });
    }
}

function mixed_section_1(segments) {
    const $mixed = $('.mixed-sections');
    if (!$mixed.length) return;

    const sections = $('.sections');
    let windowHeight = $(window).height();
    let scrollY = $(window).scrollTop();

    let parentTop = $mixed.offset().top;

    if (scrollY + windowHeight < parentTop) {
        return;
    }

    sections.each(function(index) {
        if (!$(this).hasClass('section-1')) return;

        let frames = $(this).find('.imagesScroll');
        
        let targetImgsSection = frames.find('.imgsSection:visible');
        let totalImgs = targetImgsSection.find('img').length;

        let segStart = segments[index].start;
        let segHold = segments[index].hold;

        let scrollRelative = scrollY - parentTop - segStart + windowHeight;
        if (scrollRelative < 0) scrollRelative = 0;
        if (scrollRelative > segHold) scrollRelative = segHold;

        let idx = Math.floor((scrollRelative / segHold) * totalImgs);

        if (idx >= 0 && idx < totalImgs) {
            targetImgsSection.find('img').eq(idx).show().siblings().hide();

            let currentFrame = targetImgsSection.find('img').index(
                targetImgsSection.find('img[style!="display: none;"]').first()
            );

            if (currentFrame > 56)
                frames.find('.container').fadeIn();
            else
                frames.find('.container').fadeOut();
            
        }
    });
}

$('.mixed-sections .section-1 .btn-specs').on('click', function() {
    let el = $(this).parents('.mixed-sections');

    el.find('.specs-container').fadeIn();
    $('body').css('overflow-y', 'hidden');
});

$('.mixed-sections .specs-close, .mixed-sections .overlay').on('click', function() {
    let el = $(this).parents('.mixed-sections');

    el.find('.specs-container').fadeOut();
    $('body').css('overflow-y', 'visible');
});